export default __webpack_public_path__ + "static/media/Opening Traditional Dance.78f26ea0.JPG";